(() => {
  const normalizeSlot = (value) => String(value || '').replace(/\s*[–—-]\s*/g, ' - ');

  const ready = () => {
    document.querySelectorAll('[data-pdp-root]').forEach((root) => {
      const form = root.querySelector('[data-pdp-form]');
      const scheduler = root.querySelector('[data-delivery-scheduler]');
      if (!form || !scheduler) return;

      const internalDate = scheduler.querySelector('[data-pdp-date]');
      const dateProperty = scheduler.querySelector('[data-buunto-date-input]');
      const timeProperty = scheduler.querySelector('[data-delivery-slot-input]');
      const selectionProperty = scheduler.querySelector('[data-buunto-selection]');
      const confirm = scheduler.querySelector('[data-delivery-confirm]');
      if (!internalDate || !dateProperty || !timeProperty || !selectionProperty) return;

      const syncSelection = () => {
        const selectedDate = scheduler.querySelector('[data-calendar-days] button.is-selected')?.dataset.date || internalDate.value;
        const selectedSlot = scheduler.querySelector('[data-delivery-slot].is-selected')?.dataset.deliverySlot || timeProperty.value;
        if (!selectedDate || !selectedSlot) return false;

        const method = root.querySelector('[data-receive-method]:checked');
        const methodCode = method?.dataset.buuntoMethod || 'LOCAL_DELIVERY';
        const date = new Date(selectedDate + 'T12:00:00');
        if (Number.isNaN(date.getTime())) return false;

        const displayDate = new Intl.DateTimeFormat('ro-RO', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }).format(date);
        const displaySlot = normalizeSlot(selectedSlot);

        internalDate.value = selectedDate;
        dateProperty.value = displayDate;
        timeProperty.value = displaySlot;
        selectionProperty.value = methodCode + '|' + selectedDate + '|' + displaySlot + '|';
        return true;
      };

      confirm?.addEventListener('click', syncSelection);
      root.querySelectorAll('[data-receive-method]').forEach((input) => {
        input.addEventListener('change', syncSelection);
      });

      form.addEventListener('submit', syncSelection, { capture: true });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
